import React from 'react'

function Guidance() {
  return (
    <div>
        Guidance
    </div>
  )
}

export default Guidance